import styled from "@emotion/styled";
import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { Loader } from "components/Loader/Loader";
import Report from "pages/Report/Report";

//@ts-ignore
// const UploadPage = lazy(() => import('./pages/UploadPage'));

export const LoaderContainer = styled.div(() => ({
  width: "100%",
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const AppRoutes = () => (
  <>
    <Suspense
      fallback={
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      }
    >
      <Routes>
        <Route path="/" element={<Report />} />

        {/* </div> */}
      </Routes>
    </Suspense>
  </>
);
